import {createApp} from '../../../../../vendor/Vue3/vue.esm-browser.prod.min.js'

export default class SearchList {
    constructor($el) {
        this.$el = $el;
        this.createVueApp = this.createVueApp.bind(this);

        this.createVueApp();
    }

    /**
     * Create Vue application
     */
    createVueApp() {
        const app = createApp(this.app());
        app.config.compilerOptions.delimiters = ['v{', '}'];
        app.mount(this.$el);
    }

    /**
     * Returns the actual Vue app
     * @returns {{mounted(): void}}
     */
    app() {
        const $el = this.$el;
        const $html = document.querySelector('html');

        return {
            data() {
                return {
                    searchTerm: '',
                    items: [],
                    noItemsShown: false
                }
            },
            watch: {
                searchTerm() {
                    this.performFlip();
                }
            },
            methods: {
                clearSearchTerm() {
                    this.searchTerm = '';
                },
                async performFlip() {
                    const search = this.searchTerm.toLowerCase();
                    const toHide = [];
                    const toShow = [];

                    let matchedAmount = 0;
                    this.items.forEach(item => {
                        const matches = item.dataset.searchListItem.toLowerCase().includes(search);

                        if (matches) {
                            matchedAmount += 1;
                        }

                        const isVisible = !item.classList.contains('no-display');

                        if (isVisible && !matches) {
                            toHide.push(item)
                        }

                        if (!isVisible && matches) {
                            toShow.push(item);
                        }
                    });

                    toHide.forEach(item => item.classList.add('hidden'));

                    if (toHide.length > 0) {
                        await new Promise(resolve => setTimeout(resolve, 140));
                    }

                    const firstPositions = this.getVisiblePositions();

                    toHide.forEach(item => item.classList.add('no-display'));
                    toShow.forEach(item => {
                        item.classList.remove('no-display');
                        item.classList.add('hidden');
                    });

                    requestAnimationFrame(() => {
                        // while performing the animations we don't want scrolling to be enabled
                        $html.classList.add('no-scroll');

                        const lastPositions = this.getVisiblePositions();

                        this.items.forEach((item, index) => {
                            const first = firstPositions[index];
                            const last = lastPositions[index];

                            if (first && last) {
                                const dx = first.left - last.left;
                                const dy = first.top - last.top;

                                if (dx !== 0 || dy !== 0) {
                                    item.style.transition = 'none';
                                    item.style.transform = `translate(${dx}px, ${dy}px)`;
                                    item.offsetHeight; // Force reflow

                                    requestAnimationFrame(() => {
                                        item.style.transition = 'transform 0.28s ease, opacity 0.56s ease';
                                        item.style.transform = 'translate(0, 0)';
                                    });
                                }
                            }
                        });

                        requestAnimationFrame(() => {
                            toShow.forEach(item => item.classList.remove('hidden'));

                            this.noItemsShown = matchedAmount === 0;

                            // re-enable scrolling
                            $html.classList.remove('no-scroll');
                        });
                    });
                },

                getVisiblePositions() {
                    const positions = {};
                    this.items.forEach((item, index) => {
                        if (item.offsetParent !== null) {
                            const rect = item.getBoundingClientRect();
                            positions[index] = {top: rect.top, left: rect.left};
                        }
                    });
                    return positions;
                },

                applyFilter() {
                    const search = this.searchTerm.toLowerCase();
                    let hasChanged = false;

                    this.items.forEach(item => {
                        const data = item.dataset.searchListItem.toLowerCase();
                        const shouldShow = data.includes(search);
                        const isCurrentlyHidden = item.classList.contains('no-display');

                        if (shouldShow && isCurrentlyHidden) {
                            item.classList.remove('no-display');
                            item.style.opacity = '0';
                            requestAnimationFrame(() => item.style.opacity = '1');
                            hasChanged = true;
                        } else if (!shouldShow && !isCurrentlyHidden) {
                            item.classList.add('no-display');
                            hasChanged = true;
                        }
                    });

                    return hasChanged;
                }
            },
            mounted() {
                this.items = Array.from($el.querySelectorAll('[data-search-list-item]'));
                $el.querySelector('input.search-list__input').focus();
            }
        }
    }
}
